export const SERVER_ERROR = "Server not reached";

// Tags & Courses
export const WORDING_ERROR = "Libellé doit avoir au moins 4 caractères";
export const COURSE_DESCRIPTION_ERROR = "Description doit avoir au moins 4 caractères";
export const COURSE_TAGS_ERROR = "Au moins une catégorie obligatoire";

// Paragraphs
export const PARAGRAPH_TITLE_ERROR = "Un paragraphe doit avoir un titre";
export const PARAGRAPH_CONTENT_ERROR = "Un paragraphe doit avoir un contenu";
export const PARAGRAPH_LESSON_ERROR = "Un paragraphe doit avoir un leçon";
export const PARAGRAPH_RANK_ERROR = "Un paragraphe doit avoir un rang valide";
export const SHOW_ERROR = "Le champs affiche est obligatoire";

// Quizzes
export const QUIZ_TITLE_ERROR = "Un quiz doit avoir un titre";
export const QUIZ_RESUME_ERROR = "Un quiz doit avoir un résumé";
export const QUIZ_LESSON_ERROR = "Un quiz doit avoir un leçon";

// Questions
export const QUESTION_RANK_ERROR = "Une question doit avoir un rang valide";
export const QUESTION_ERROR = "Question non valide";
export const UNIQ_ERROR = "Le champs unique est obligatoire";

// Responses
export const RESPONSE_RANK_ERROR = "Une réponse doit avoir un rang valide";
export const RESPONSE_ERROR = "Une reponse est obligatoire";
export const RESPONSE_STATUS_ERROR = "Une reponse doit avoir un status";
export const RESPONSE_UNIQ = "La question doit avoir une seule bonne réponse";

// Users
export const EMAIL_ERROR = "Saisir un adresse mail valide";
export const FULLNAME_ERROR = "Saisir un nom complet valide";
export const TOGE_ERROR = "Le toge doit être un nombre positive ou égale 0";
export const PHONE_ERROR = "Saisir un contact valide";
export const PASSWORD_ERROR = "Mot de passe doit avoir au moins 4 caractères";
export const CONFIRM_PASSWORD_ERROR = "Mot de passe non correspond";
